<nav #navbar class="navbar active">
  <div class="container-fluid">
    <div class="navbar-header">
      <a href="#" onClick="return false;" class="navbar-toggle collapsed"
        (click)="isNavbarCollapsed = !isNavbarCollapsed" aria-expanded="false"></a>
      <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event, 'overlay-open')"></a>
      <a class="navbar-brand" routerLink="{{ homePage }}">
        <!-- <img
          src="assets/images/images-app/logo_e_sygmedic.png"
          class="logo-app"
          alt=""
        /> -->
        <span class="logo-name">Gestionnaire</span>
      </a>
    </div>
    <div class="collapse navbar-collapse" [ngbCollapse]="isNavbarCollapsed">
      <!-- <ul class="float-start collapse-menu-icon">
        <li>
          <button
            mat-icon-button
            (click)="callSidemenuCollapse()"
            class="sidemenu-collapse"
          >
            <i class="material-icons-outlined icon-color"> menu </i>
          </button>
        </li>
      </ul> -->
      <ul class="float-start collapse-menu-icon">
        <li>
          <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse">
            <i class="material-icons-outlined icon-color"> menu </i>
          </button>
        </li>
      </ul>

      <!-- <div class="selected-exercice">
        <ng-select
        [(ngModel)]="selectedExercice"
        placeholder="Choisissez "
        (change)="onSelectExercice(selectedExercice)"
        name="uniteId"
        id="uniteId"
        [clearable]="false"
        [multiple]="false"
        [closeOnSelect]="true"
      >
        <ng-option
          *ngFor="let item of itemsExercice"
          [value]="item"
          >{{ item?.libelle }} ({{item?.debut | dateFormat}} - {{item?.fin | dateFormat}})
        </ng-option>
      </ng-select>

      </div> -->

      <!-- <button (click)="onStopChannel()">Stop</button> -->

      <ul class="nav navbar-nav navbar-right">
        <!-- Full Screen Button -->
        <li class="fullscreen">
          <button mat-icon-button (click)="callFullscreen()" class="nav-notification-icons">
            <i class="material-icons-outlined icon-color"> fullscreen </i>
          </button>
        </li>
        <!-- #END# Full Screen Button -->
        <!-- #START# Notifications-->
        <li class="nav-item li-notification" ngbDropdown>
          <button mat-icon-button ngbDropdownToggle class="nav-notification-icons"
            (click)="openToogle((isOpen = !isOpen))">
            <i class="material-icons-outlined icon-color">
              notifications_active
            </i>
            <span class="notif-badge">
              {{ listeNotifications?.length > 9 ? '9+' : listeNotifications?.length }}
            </span>
          </button>
          <div ngbDropdownMenu class="notification-dropdown pullDown">
            <div class="noti-list" style="position: relative; max-width: 700px; max-height: 450px" [perfectScrollbar]>
              <ul class="menu">
                <li class="nfc-header">
                  <h5 class="mb-0">Notifications</h5>
                </li>

                <li *ngIf="!listeNotifications || listeNotifications?.length == 0" style="text-align: center">
                  Aucune notification disponible
                </li>

                <li>
                  <a href="#" *ngFor="let notification of listeNotifications" onClick="return false;"
                    style="border-top: 1px solid #eceeee">
                    <!-- <span class="table-img msg-user">
                      <i class="fa fa-plus" [ngClass]="{'nfc-green' : notification.typeNotificationId == 1}"></i>
                    </span> -->
                    <span class="menu-info">
                      <span class="menu-title">{{ notification?.libelle }}
                      </span>
                      <span class="menu-desc mt-2">
                        <i class="material-icons">access_time</i>
                        {{ getDuree(notification.created_at) }}
                      </span>
                    </span>
                    <span class="nfc-close">
                      <b *ngIf="notification.has_validation" class="badge badge-success pull-right" (click)="
                        openModal(notification, templateTraiterDossier)
                      ">
                        Traiter
                      </b>
                      <b *ngIf="!notification.has_validation" class="badge badge-success pull-right" (click)="
                        openModal(notification, templateVisualiserNotif)
                      ">
                        Lire
                      </b>
                      <!-- <b
                        *ngIf="notification?.has_validation"
                        class="badge badge-success pull-right"
                        (click)="
                          openModal(notification, templateTraiterDossier)
                        "
                      >
                        Traiter
                      </b>
                      <b
                        *ngIf="!notification?.has_validation"
                        class="badge badge-danger pull-right"
                        (click)="
                          onReadNotification(notification)
                        "
                      >
                      Marquer lu
                      </b> -->
                      <!-- <b
                        *ngIf="
                          !notification?.has_validation &&
                          (notification?.code?.toLowerCase() ==
                            codeCirucit?.RADIO?.toLowerCase() ||
                            notification?.code?.toLowerCase() ==
                              codeCirucit?.LABO?.toLowerCase())
                        "
                        class="badge badge-danger pull-right"
                        (click)="
                          openModal(notification, templateVisualiserResulat)
                        "
                        >Interprètation
                      </b>
                      <b
                        *ngIf="
                          !notification?.has_validation &&
                          notification?.code?.toLowerCase() ==
                            codeCirucit?.RES_RADIO?.toLowerCase()
                        "
                        class="badge badge-warning pull-right"
                        (click)="
                          openModal(notification, templateVisualiserResulat)
                        "
                      >
                        Résultat
                      </b> -->
                      <!-- <app-feather-icons [icon]="'x'" [class]="'user-menu-icons'"></app-feather-icons> -->
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <!-- <a class="nfc-read-more"> Toutes les notifications</a> -->
          </div>
        </li>
        <!-- #END# Notifications-->
        <!-- <li class="nav-item" ngbDropdown>
          <a ngbDropdownToggle class="lang-dropdown">
            <img *ngIf="flagvalue !== undefined" src="{{flagvalue}}" height="16">
            <img *ngIf="flagvalue === undefined" src="{{defaultFlag}}" height="16">
          </a>
          <div ngbDropdownMenu class="dropdown-menu lang-item dropdown-menu-right pullDown">
            <a href="javascript:void(0);" class="dropdown-item lang-item-list" *ngFor="let item of listLang"
              (click)="setLanguage(item.text, item.lang, item.flag)"
              [ngClass]="{'active': langStoreValue === item.lang}">
              <img src="{{item.flag}}" class="flag-img" height="12"> <span class="align-middle">{{item.text}}</span>
            </a>
          </div>
        </li> -->
        <li class="nav-item user_profile" ngbDropdown>
          <div class="chip nav-notification-icons pt-0" ngbDropdownToggle>
            <img src="{{ userImg }}" class="user_img" width="32" height="32" alt="User" />
            <div class="user-info-compact">
              <span class="user-name">{{ currentUser?.nom + ' ' + currentUser?.prenom | uppercase }}</span>
              <span class="user-role">{{ (currentUser?.role + ' - ' + currentUser?.filiale_libelle) | uppercase
                }}</span>
            </div>
          </div>
          <div ngbDropdownMenu class="notification-dropdown pullDown">
            <div class="noti-list" style="position: relative; max-width: 600px; max-height: 300px" [perfectScrollbar]>
              <ul class="menu">
                <li class="body">
                  <ul class="user_dw_menu">
                    <li>
                      <!-- <a
                        href="#"
                        onClick="return false;"
                        (click)="updatePassword()"
                      > -->
                      <a href="#" onClick="return false;" (click)="onStopChannel()">
                        <app-feather-icons [icon]="'user'" [class]="'user-menu-icons'"></app-feather-icons>Modifier mot
                        de passe
                      </a>
                    </li>
                    <!-- <li>
                      <a href="#" onClick="return false;">
                        <app-feather-icons [icon]="'mail'" [class]="'user-menu-icons'"></app-feather-icons>Inbox
                      </a>
                    </li>
                    <li>
                      <a href="#" onClick="return false;">
                        <app-feather-icons [icon]="'settings'" [class]="'user-menu-icons'"></app-feather-icons>Settings
                      </a>
                    </li> -->
                    <li>
                      <a href="javascript:void(0);" (click)="logout()">
                        <app-feather-icons [icon]="'log-out'" [class]="'user-menu-icons'"></app-feather-icons>
                        Deconnexion
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <!-- #END# Tasks -->
      </ul>
    </div>
  </div>
</nav>

<!-- Traiter demande -->
<ng-template #templateTraiterDossier>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Traitement de demande</h4>
    <button mat-icon-button class="pull-right" (click)="modalRef.hide()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-body" [ngBusy]="{
      busy: busySave,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <form class="m-1">
      <div class="row">
        <!-- <app-form-etape-validation></app-form-etape-validation> -->
        <div class="container-fluid mt-4">
          <div class="row">
            <!-- Partie gauche : Tableau des éléments à valider -->
            <div class="col-md-8">

              <mat-tab-group mat-align-tabs="start" #tabGroup (selectedIndexChange)="selectedChangeValue($event)"
                [(selectedIndex)]="indiceTab">
                <mat-tab label="Validation">
                  <div *ngIf="indiceTab == 0" style="overflow-x: hidden">
                    <app-form-items-validate [notification]="itemToSave"></app-form-items-validate>
                  </div>
                </mat-tab>
                <mat-tab label="Historique validation">
                  <div *ngIf="indiceTab == 1" style="overflow-x: hidden">
                    <app-form-histo-validation [selectedNotification]="itemToSave"></app-form-histo-validation>
                  </div>
                </mat-tab>

              </mat-tab-group>

            </div>
            <div class="col-md-4">
              <app-form-decision (onSubmitDecision)="onSubmitDecision($event)"></app-form-decision>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>

<ng-template #templateVisualiserNotif>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Visualisation de notification</h4>
    <button mat-icon-button class="pull-right" (click)="modalRef.hide()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-body" [ngBusy]="{
      busy: busySave,
      message: 'Veuillez patienter ...',
      backdrop: false
    }">
    <form class="m-1">
      <div class="row">
        <!-- <app-form-etape-validation></app-form-etape-validation> -->
        <div class="container-fluid mt-4">
          <div class="row">
            <!-- Partie gauche : Tableau des éléments à valider -->
            <div class="col-md-12">
              <!-- <app-form-view-notif-content [notification]="itemToSave"></app-form-view-notif-content> -->
              <app-form-items-validate [notification]="itemToSave"></app-form-items-validate>
            </div>
            <div class="col-md-12" style="text-align: center;">
              <button class="btn btn-primary" (click)="confirmMarkAsRead(itemToSave)">Marquer comme lu</button>
            </div>

          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>